import { getTokenDefinition } from "@bracket/chainography";
import type { TokenIdentifier } from "@bracket/types";
import * as G from "@globals";
import { wagmiConfig as config } from "@wagmiconfig";
import { getBalance, } from "wagmi/actions";



/**
 * Retrieves the balance of the denomination token of a vault for the connected wallet.
 *
 * @remark this requires the token be argued which effectively makes it a "balance of any token" function..... quite stupid.
 * @param {TokenIdentifier} token - The identifier of the token to get the balance for
 * @returns {Promise<bigint>} The token balance as a bigint value
 *
 * @throws {Error} If no wallet address is found
 *
 * @remarks
 * This function:
 * 1. Gets the connected wallet address and chain ID
 * 2. Verifies a wallet is connected
 * 3. Fetches the token balance using the token's contract address
 * 4. Returns the raw balance value
 */
export const getDenoBalance = async ( token: TokenIdentifier, ): Promise<bigint> => {

	const { address, anonymous, } = G.wallet.getBracketWallet();
	const { chainId, address: tokenAddress } = getTokenDefinition(token);
	if(!address)
		throw new Error("No address found");

	if(anonymous) {
		return BigInt(0);
	}

	if(!(address in cached)) {
		cached[ address ] = {}
	}
	if(!(tokenAddress in cached[address])) {
		cached[address][tokenAddress] = {
			fetching: false,
			since: 0,
			value: BigInt(0),
		}
	}
	const segment = cached[address][tokenAddress];
	const { since, fetching, value, } = segment;

	if(since > (Date.now() - interval)) {
		return value;
	}

	if(fetching) {
		return awaitDenoBalance(address, tokenAddress);
	}

	cached[address][tokenAddress].fetching = true;

	const { value:next } = await getBalance(config, {
		address,
		token: tokenAddress,
		chainId,
	});

	cached[address][tokenAddress].value = next;
	cached[address][tokenAddress].fetching = false;
	cached[address][tokenAddress].since = Date.now();

	return cached[address][tokenAddress].value;

};

const interval = 10 * 1000;

const cached: Record<string, Record<string, { fetching: boolean; since: number; value: bigint; }>> = {};

const awaitDenoBalance =(address: string, tokenAddress: string): Promise<bigint> => {
	return new Promise((resolve, reject) => {

		const to = setTimeout(() => {
			reject(new Error("Deno balance fetch timed out"));
			clearTimeout(to);
		}, 5000);

		const inte = setInterval(() => {
			const { fetching, since, value, } = cached[address][tokenAddress];
			if(!fetching) {
				if(since < (Date.now() - interval)) {
					console.warn("Deno balance outdated but issuing anyway", address, tokenAddress);
				}
				clearInterval(inte);
				clearTimeout(to);
				resolve(value);
			}
		}, 25);

	});
}
